export default "__VITE_ASSET__DPod6oix__"